import { render, staticRenderFns } from "./PedidosModule.vue?vue&type=template&id=3e0f7cab&scoped=true&"
import script from "./PedidosModule.vue?vue&type=script&lang=js&"
export * from "./PedidosModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0f7cab",
  null
  
)

export default component.exports